module.exports = __webpack_public_path__ + "static/media/improvement-idea-blue.7e7e3570.png";